import { Field } from "enums";
import Validation from "services/validation.service";
import lang from "translations";

const initialFormState = (initialState = {}) => {
  const {
    name = "",
    defaultCapacity = 0,
    defaultCleanupDuration = 0,
    shape = "",
    defaultReservationDuration = 0,
    minimumSpentAmount = 0,
    isActive = true,
  } = initialState;

  return {
    name: {
      name: "name",
      value: name,
      type: Field.INPUT,
      label: lang.name,
      validations: [Validation.required()],
      required: true,
      maxLength: 75,
    },
    defaultCapacity: {
      name: "defaultCapacity",
      value: defaultCapacity,
      type: Field.INPUT,
      label: lang.defaultCapacity || "Default Capacity",
      validations: [Validation.required()],
      required: true,
      maxLength: 10,
    },
    defaultCleanupDuration: {
      name: "defaultCleanupDuration",
      value: defaultCleanupDuration,
      type: Field.INPUT,
      label: lang.defaultCleanupDuration || "Default Cleanup Duration",
      validations: [Validation.required()],
      required: true,
      maxLength: 10,
    },
    shape: {
      name: "shape",
      value: shape,
      type: Field.INPUT,
      label: lang.shape,
      validations: [Validation.required()],
      required: true,
      maxLength: 50,
    },
    defaultReservationDuration: {
      name: "defaultReservationDuration",
      value: defaultReservationDuration,
      type: Field.NUMBER,
      label: lang.defaultReservationDuration || "Default Reservation Duration",
      validations: [Validation.required()],
      required: true,
      maxLength: 10,
    },
    minimumSpentAmount: {
      name: "minimumSpentAmount",
      value: minimumSpentAmount,
      type: Field.INPUT,
      label: lang.minimumSpentAmount || "Minimum Spent Amount",
      validations: [Validation.required()],
      required: true,
      maxLength: 10,
    },
    isActive: {
      name: "isActive",
      value: isActive,
      type: Field.CHECKBOX,
      label: lang.active,
    },
  };
};

export default initialFormState;
